export default "__VITE_ASSET__DLt3h$om__"